import { Radio } from '@mantine/core';
import { MouseEvent } from 'react';

import { CollectionActionScope } from '@/models/appointment/Appointment.ts';

interface Props {
    selectedScope: CollectionActionScope;
    onChange: (scope: CollectionActionScope) => void;
    isEditMode?: boolean;
}

const handleClick = (e: MouseEvent): void => {
    // Prevent click events from bubbling up to parent components
    e.stopPropagation();
};

export const CollectionScopeSelector = ({ selectedScope, onChange, isEditMode }: Props) => {
    const handleChange = (value: string): void => {
        onChange(value as CollectionActionScope);
    };

    return (
        <Radio.Group value={selectedScope} onChange={handleChange} onClick={handleClick}>
            <div className="flex flex-col gap-2">
                <Radio.Card
                    value={CollectionActionScope.SINGLE}
                    className="cursor-pointer rounded-lg border bg-white p-3 data-[checked]:border-primary"
                >
                    <div className="flex items-center gap-3">
                        <Radio.Indicator />
                        <div className="flex flex-col">
                            <span className="text-sm font-semibold text-gray-900">Nur diesen Termin</span>
                            <span className="text-xs text-slate-500">
                                {isEditMode
                                    ? 'Bearbeitet nur den ausgewählten Termin'
                                    : 'Löscht nur den ausgewählten Termin'}
                            </span>
                        </div>
                    </div>
                </Radio.Card>

                <Radio.Card
                    value={CollectionActionScope.ALL_FUTURE}
                    className="cursor-pointer rounded-lg border bg-white p-3 data-[checked]:border-primary"
                >
                    <div className="flex items-center gap-3">
                        <Radio.Indicator />
                        <div className="flex flex-col">
                            <span className="text-sm font-semibold text-gray-900">Alle zukünftigen Termine</span>
                            <span className="text-xs text-slate-500">
                                {isEditMode
                                    ? 'Bearbeitet diesen und alle zukünftigen Termine'
                                    : 'Löscht diesen und alle zukünftigen Termine'}
                            </span>
                        </div>
                    </div>
                </Radio.Card>
            </div>
        </Radio.Group>
    );
};
